import * as ChartJS from 'chart.js/auto';
import CryptoJS from 'crypto-js';
import * as levenshtein from 'fast-levenshtein';
import hljs from 'highlight.js';
import $ from 'jquery';
import _ from 'lodash';
import momentJSRaw from 'moment';
import Mousetrap from 'mousetrap';
import * as pdfjsLib from 'pdfjs-dist';
import PouchDB from 'pouchdb-browser';
import * as qr from 'qrcode';
import * as React from 'react';
import * as Charts from 'react-chartjs-2';
import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import { renderToStaticMarkup } from 'react-dom/server';
import * as sortable from 'react-sortablejs';
import * as showdown from 'showdown';
import * as swiper from 'swiper';
import * as swiperModules from 'swiper/modules';
import * as swiperReact from 'swiper/react';
import { twMerge } from 'tailwind-merge';
import { match, P as matchP } from 'ts-pattern';
import * as wouter from 'wouter';
import * as xlsx from 'xlsx-js-style';
PouchDB.plugin(require('crypto-pouch'));
export { $, _, ChartJS, Charts, CryptoJS, hljs, levenshtein, match, matchP, momentJSRaw, Mousetrap, pdfjsLib, PouchDB, qr, React, ReactDOM, ReactDOMClient, renderToStaticMarkup, showdown, sortable, swiper, swiperModules, swiperReact, twMerge, wouter, xlsx, };
//# sourceMappingURL=index.js.map